export default __webpack_public_path__ + "static/media/colombia_flag.88585927.svg";